import {Component, OnInit} from '@angular/core';
import { HttpServices } from '../../services/http-services';
import { LoraDevices } from '../../interfaces/lora-devices';
import { DeviceListTableHeader } from '../../models/DeviceListTableHeader';
import { LocalDataSource } from 'ng2-smart-table';
import { Router, NavigationExtras } from '@angular/router';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'device-list',
  templateUrl: 'devices-list.template.html',
  styleUrls: ['device-list.style.scss']
})

export class DeviceListComponent implements OnInit {
  allDeviceQuantity: number;
  allActiveDeviceQuantity: number;
  allPassiveDeviceQuantity: number;
  loraDevices: LoraDevices = {nodes: [], activeDevices: 0};
  error: any;
  settings = DeviceListTableHeader;
  source: LocalDataSource;

  public doughnutChartLabels: string[] = ['Вышедшие на связь', 'Не вышедшие на связь', 'Аварии'];
  public doughnutChartData: number[] = [];
  public doughnutChartType: string = 'doughnut';
  public ChartLegend:boolean = true;
  public ChartOptions:any = {
    responsive: true
  };
  public ChartColors: Array<any> = [
    {
      backgroundColor: ['#5cb85c', '#f0ad4e', '#d9534f']
      // borderColor: '#5cb85c'
    }
  ];

  constructor (private deviceTableService: HttpServices, private router: Router, private alert: AlertService) {  }

    ngOnInit () {
      this.getAllDiveces ();
    }

    getAllDiveces () {
      this.deviceTableService.getDevice()
        .subscribe(
          (data: LoraDevices) => {
            this.loraDevices = data;
            this.source = new LocalDataSource(this.loraDevices.nodes);
            this.allDeviceQuantity = this.loraDevices.nodes.length;
            this.allActiveDeviceQuantity = this.loraDevices.activeDevices;
            this.allPassiveDeviceQuantity = this.allDeviceQuantity - this.allActiveDeviceQuantity;
            this.alert.success('Актуальный список устройств загружен');
            const dynamicGraph: number[] = [];
            dynamicGraph.push(this.allActiveDeviceQuantity);
            dynamicGraph.push(this.allDeviceQuantity - this.allActiveDeviceQuantity);
            dynamicGraph.push(0);
            this.doughnutChartData = dynamicGraph;
          },
          error => {
            this.error = error;
            this.alert.error('Загрузка списка устройств не удалась');
            console.log(error);
          }
        );
    }
    selectDevice ($event) {
      const navigationExtras: NavigationExtras = {
        queryParams: { 'euiRequest': $event.data.eui, 'IDRequest': $event.data.id}
      };
      this.alert.info('Переход к устройству ' + $event.data.eui);
      this.router.navigate(
        ['/device-info'],
        navigationExtras);

    };
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/devices-list/devices-list.component.ts